import DatabaseModel from './DatabaseModel.js';

var GrupoCliente = Object.create(DatabaseModel);

GrupoCliente.model = 'grupocliente';
GrupoCliente.modelFront = 'gruposcliente';

export default GrupoCliente;